export const SHARE_URLS = {
  facebook: 'https://www.facebook.com/sharer/sharer.php',
  twitter: 'https://twitter.com/intent/tweet',
  telegram: 'https://t.me/share/url',
  reddit: 'https://www.reddit.com/submit',
  whatsapp: 'https://wa.me/',
} as const;
